import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputField from './InputField';

export default class AlertDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            input_object: {},
            input_valid: false
        }
    }
    
    handleClose = () => {
        this.props.callBack(this.props.buttons[1]? this.props.buttons[1] : false );
        this.setState({open:false});
    };

    handleFieldUpdate = (fieldObj) => {
        // eslint-disable-next-line eqeqeq
        if (fieldObj.value==''){fieldObj.value=null}

        let validation = false;
        if (fieldObj.value){
            if (fieldObj.value.length >= this.props.fieldSpec.f_minLength){
                validation = true;
            }
        }
        // console.log('validation :>> ', validation);
        this.setState({input_object:fieldObj, input_valid: validation});
    }

    render() {
        return (
            <div>
            <Dialog
                open={this.state.open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" dangerouslySetInnerHTML={{__html: this.props.description}} />
                </DialogContent>

                {this.props.textInput&&                
                <div style={{width:'30%', alignSelf:'center'}}>
                    <InputField 
                        fieldMap={this.props.fieldSpec}
                        setField={this.handleFieldUpdate}
                    />
                </div>}

                <DialogActions>

                    <Button 
                        onClick={this.handleClick}
                        id={this.props.buttons[0]}
                        color="primary"
                        disabled={this.props.textInput&&this.props.fieldSpec.f_required&&!this.state.input_valid}
                    >
                        {this.props.buttons[0]}
                    </Button>

                    {this.props.buttons[1]&&
                    <Button onClick={this.handleClick} id={this.props.buttons[1]} color="secondary">
                        {this.props.buttons[1]}
                    </Button>}

                </DialogActions>
            </Dialog>
            </div>
        );
    }

    handleClick = (e) => {
        if (this.props.callBack){
            if (this.props.textInput){
                this.props.callBack({result: e.currentTarget.id, input_object: this.state.input_object});
            } else {
                this.props.callBack(e.currentTarget.id);
            }
        }
        this.setState({open:false});
    }


}
